<template>
  <NavBar :progress="50" titleSuffix="tevredenheidsonderzoek" customBase="vragenlijst/" />
  <div class="outer-container">
    <router-link :to="{ name: 'SurveyTiredEyes', params: { 'opticienId': $route.params.opticienId, 'companyId': $route.params.companyId } }">
      <img class="arrow-back" alt="arrow" src="../../assets/arrow-left.svg">
    </router-link>
    <div class="question">
      <div class="content-title">
        5 / 10
      </div>
<!--      Has used other glasses before-->
      <scale-question
        v-if="getUsedOther()"
        :selected-value="getSharperVision()"
        @update:selectedValue="selectedValue"
        lowQuote="Ik merk geen verschil"
        highQuote="Ja, veel scherper <i>met</i> mijn nieuwe beeldschermbril."
      >
        Zie je <i>met</i> je nieuwe beeldschermbril scherper op<br/>
        verschillende kijkafstanden (op je telefoon,<br/>
        document op bureau, beeldscherm), dan <i>met je</i><br/>
        <i>andere beeldschermbril</i>?
      </scale-question>
<!--      Not used other glasses before -->
      <scale-question
        v-if="!getUsedOther()"
        :selected-value="getSharperVision()"
        @update:selectedValue="selectedValue"
        lowQuote="Ik merk geen verschil"
        highQuote="Ja, veel scherper <i>met</i> mijn nieuwe beeldschermbril."
      >
        Zie je <i>met</i> beeldschermbril scherper op<br/>
        verschillende kijkafstanden (op je telefoon,<br/>
        document op bureau, beeldscherm), dan <i>zonder</i>?
      </scale-question>
    </div>
  </div>
</template>

<script>
  import NavBar from "@/components/NavBar";
  import ScaleQuestion from "@/components/ScaleQuestion";
  import {createNamespacedHelpers} from "vuex";
  const {mapGetters, mapMutations} = createNamespacedHelpers('survey');

  export default {
    name: "SurveySharperVision",
    components: {
      ScaleQuestion,
      NavBar
    },
    methods: {
      ...mapGetters(["getUsedOther", "getTiredEyes", "getSharperVision"]),
      ...mapMutations(["setSharperVision"]),
      selectedValue(newValue) {
        this.setSharperVision(newValue);
        this.$router.push(
          {
            name: 'SurveyLessPain',
            params: {
              'opticienId': this.$route.params.opticienId,
              'companyId': this.$route.params.companyId
            }
          }
        );
      }
    },
    created() {
      // Navigate back when no previous answer found.
      if (this.getTiredEyes() === undefined) this.$router.push(
          {
            name: 'SurveyTiredEyes',
            params: {
              'opticienId': this.$route.params.opticienId,
              'companyId': this.$route.params.companyId
            }
          }
      );
    }
  }
</script>

<style scoped>
  .content-title {
    font-weight: bold;
  }

  .question {
    margin-top: 8rem;

    display: inline-flex;
    flex-direction: column;
    gap: 1.5rem;
  }
</style>